<template>
  <v-btn
    variant="text"
    class="main-nav-btn mx-1"
    size="small"
    v-bind="$attrs"
  >
    <!-- <v-icon class="mr-1" size="small">{{ icon }}</v-icon> -->
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseMainNavBtn',

  inheritAttrs: false,

  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
};
</script>
